export class Item {
    public id: string;
    public text: string;
    public options: Array<Item>;
    public parent: Item;
    public disabled: boolean = false;
    public checked: boolean = false;
    public label: string;

    public constructor(source:any) {
        if (typeof source === "object") {
            this.id = source.id;
            this.text = source.text;
            this.label = source.text;
            this.disabled = source.disabled ? source.disabled : false;
            if (source.options) {
                this.options = source.options.map((option:any) => {
                    let item:Item = new Item(option);
                    item.parent = this;
                    item.label = ("<b>"+item.parent.text+"</b> | " + item.text).replace(/ /g, "&nbsp;");
                    item.checked = option.checked?option.checked:false;
                    return item;
                });
            }
        }
    }

    public hasOptions():boolean {
        return this.options && this.options.length > 0;
    }

    public getSimilar():Item {
        let r:Item = new Item(false);
        r.id = this.id;
        r.text = this.text;
        r.parent = this.parent;
        return r;
    }
}